import { SaveOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Link } from 'react-router-dom';

import { SETTINGS_PATH } from '@app/constants/navigation';

import type { FC } from 'react';

import '@pages/Notifications/styles/NotificationsButtons.desktop.scss';

type TNotificationsButtonsProps = {
  onSave: () => void;
  isSaveDisabled?: boolean;
  disabled?: boolean;
};

export const NotificationsButtons: FC<TNotificationsButtonsProps> = ({
  onSave,
  isSaveDisabled = false,
  disabled = false,
}) => (
  <div className="bc-notifications-buttons">
    <Link to={SETTINGS_PATH}>
      <Button size="large" data-testid="cancel" disabled={disabled}>
        Отменить
      </Button>
    </Link>
    <Button
      type="primary"
      icon={<SaveOutlined />}
      onClick={onSave}
      disabled={isSaveDisabled || disabled}
      size="large"
      data-testid="save"
    >
      Сохранить
    </Button>
  </div>
);
